import React from 'react';
import './App.css';
import AppRouter from "./router/router";
import Navbar from "./components/navbar/navbar";
import Footer from "./components/footer/footer";
import CallButton from "./components/call-button/call-button";
import CookieBanner from "./components/cookie/CookieBanner";

function App() {
    return (
        <div className="App">
            <Navbar />
            <AppRouter/>
            <CookieBanner />
            <Footer/>
            <CallButton />
        </div>
    );
}

export default App;
